class AiryBlindsDirectCheckout {
  constructor(button) {
    this.button = button;
    this.form = button.closest('form[action*="/cart/add"]');
    this.defaultLabel = button.textContent.trim();
  }

  async checkout() {
    if (!this.form || this.button.disabled) return;

    const submitButton = this.form.querySelector('[name="add"]');
    if (submitButton?.disabled) return;

    this.setLoading(true);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(this.form),
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || 'This selection could not be added. Please review the size and try again.');
      }

      window.location.assign(`${window.Shopify.routes.root}checkout`);
    } catch (error) {
      const errorBox = this.form.querySelector('.product-form__error-message');
      if (errorBox) {
        errorBox.textContent = error.message;
        errorBox.hidden = false;
      } else {
        window.alert(error.message);
      }
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    this.button.disabled = isLoading;
    this.button.textContent = isLoading ? 'OPENING SECURE CHECKOUT...' : this.defaultLabel;
  }
}

function initializeAiryBlindsProductPage(root = document) {
  root.querySelectorAll('.jdgm-rev-widg').forEach((widget) => {
    const count = Number(widget.dataset.numberOfReviews || 0);
    if (count === 0) widget.closest('.shopify-section')?.setAttribute('hidden', '');
  });
}

document.addEventListener('DOMContentLoaded', () => initializeAiryBlindsProductPage());
document.addEventListener('shopify:section:load', (event) => initializeAiryBlindsProductPage(event.target));
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-airyblinds-direct-checkout]');
  if (!button) return;
  new AiryBlindsDirectCheckout(button).checkout();
});

// Prevent the desktop sticky bar from covering the ready-size product's main add button.
function initializeAiryBlindsReadySizeStickyGuard() {
  const productInfo = document.querySelector(
    'product-info[data-url="/products/cordless-solid-wood-blinds"]'
  );
  if (!productInfo || productInfo.dataset.abStickyGuard === 'true') return;
  productInfo.dataset.abStickyGuard = 'true';

  let frame = 0;
  const sync = () => {
    frame = 0;
    const stickyBar = document.querySelector('.sticky-atc-bar');
    const mainButton = productInfo.querySelector('[id^="ProductSubmitButton-"]');
    if (!stickyBar) return;
    const rect = mainButton?.getBoundingClientRect();
    const mainButtonVisible = Boolean(
      window.matchMedia('(min-width: 768px)').matches &&
      mainButton &&
      !mainButton.disabled &&
      rect &&
      rect.width > 0 &&
      rect.height > 0 &&
      rect.top < window.innerHeight &&
      rect.bottom > 0
    );
    stickyBar.classList.toggle('ab-hide-while-main-atc-visible', mainButtonVisible);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(sync);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  productInfo.addEventListener('change', () => setTimeout(schedule, 0), true);
  new MutationObserver(schedule).observe(productInfo, { childList: true, subtree: true });
  schedule();
}

document.addEventListener('DOMContentLoaded', initializeAiryBlindsReadySizeStickyGuard);
document.addEventListener('shopify:section:load', initializeAiryBlindsReadySizeStickyGuard);

// Backfill the mobile decision card while an older Shopify page-cache shard is still active.
function ensureAiryBlindsReadySizeMobileLanding() {
  const productInfo = document.querySelector(
    'product-info[data-url="/products/cordless-solid-wood-blinds"]'
  );
  if (!productInfo || productInfo.querySelector('[data-ab-stock-mobile-landing]')) return;

  const gallery = productInfo.querySelector('media-gallery');
  const galleryWrapper = gallery?.closest('motion-element') || gallery;
  const picker = productInfo.querySelector('variant-selects[data-ready-size-picker="true"]');
  if (!galleryWrapper || !picker?.id) return;

  const visiblePrice = productInfo.querySelector(
    '[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular'
  )?.textContent?.match(/\$[\d,.]+/)?.[0] || '$96.99';

  const card = document.createElement('aside');
  card.className = 'ab-stock-mobile-landing';
  card.dataset.abStockMobileLanding = '';
  card.setAttribute('aria-label', 'Ready-size ordering shortcut');
  card.innerHTML = '<div class="ab-stock-mobile-landing__offer"><span class="ab-stock-mobile-landing__eyebrow">Ready-size solid wood</span><strong data-ab-stock-mobile-price></strong></div><a class="ab-stock-mobile-landing__primary">Choose width &amp; height</a><p><span>Free shipping in contiguous U.S.</span><a href="/products/custom-solid-wood-blinds">Need a custom size?</a></p>';
  card.querySelector('[data-ab-stock-mobile-price]').textContent = 'From ' + visiblePrice;
  card.querySelector('.ab-stock-mobile-landing__primary').href = '#' + picker.id;
  galleryWrapper.insertAdjacentElement('afterend', card);
}

document.addEventListener('DOMContentLoaded', ensureAiryBlindsReadySizeMobileLanding);
document.addEventListener('shopify:section:load', ensureAiryBlindsReadySizeMobileLanding);
